<div class="restaurant-header">
  <div class="mobile-header-content">
    <div class="left-side">
      <div class="top-row">
        <h1 class="restaurant-name">{{ restaurantName }}</h1>

        @if (subtitle) {
          <p class="restaurant-subtitle">{{ subtitle }}</p>
        }

        <div class="status-container">
          @if (isClosed) {
            <span class="status closed">Closed</span>
          } @else {
            <span class="status open">
              Open{{ openingTime ? ": " + openingTime : "" }}
              @if (closingTime) {
                - {{ closingTime }}
              }
            </span>
          }

        </div>
      </div>

      <div class="meta-row">
        @if (hasInfo) {
          <span class="info-cta" (click)="openInfoModal()">
            <i class="fa-solid fa-circle-info"></i>
            Allergen & Info
          </span>
        }
      </div>

      <div class="right-side">
        <div class="order-toggle">
          <button
            type="button"
            [class.active]="orderType === 'collection'"
            [class.btn-primary]="orderType === 'collection'"
            (click)="changeOrderType('collection')"
            >
            Collection
          </button>

          <button
            type="button delivery"
            [class.active]="orderType === 'delivery'"
            [class.btn-primary]="orderType === 'delivery'"
            (click)="changeOrderType('delivery')"
            >
            Delivery
            @if (deliveryToggleNote && orderType !== 'delivery') {
              <span
                class="meta"
                >
                ({{ deliveryToggleNote }})
              </span>
            }
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="info-row">
    <span class="info-pill">
      <i class="fa-regular fa-clock"></i>
      {{ deliveryTime }} minutes
    </span>

    <span class="info-pill">
      <i class="fa-solid fa-truck"></i>
      {{ minOrder | currency: "GBP" }} minimum
    </span>

    <span class="info-pill">
      <i class="fa-regular fa-credit-card"></i>
      @if (deliveryFee === 0) {
        Free delivery
      }
      @if (deliveryFee > 0) {
        {{ deliveryFee | currency: "GBP" }} delivery
      }
    </span>
  </div>
</div>
